import { render } from "./App.vue?vue&type=template&id=13ed2f5c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13ed2f5c&lang=scss"

import exportComponent from "/home/maud/code/tutuyoutoo-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__